define('lib/backbone/Backbone.Validators',['require','translate','underscore','backbone','lib/backbone/backbone-validation-amd'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var BackboneValidation = require('lib/backbone/backbone-validation-amd');

  var customValidators = {
    validateRelated: function(value, attr, param, model) {
      if(value instanceof Backbone.Collection) {
        var validationErrors = _.compact(value.map(function(collectionModel) {
          return collectionModel.validate();
        }));

        return validationErrors.length > 0 ? validationErrors : null;
      } else if(value instanceof Backbone.Model) {
        return value.validate();
      }
    },

    nonEmptyCollection: function(value, attr, param, model) {
      if(value.isEmpty()) {
        return t("{0} cannot be empty").format(attr);
      }
    }
  };

  _.extend(BackboneValidation.validators, customValidators);
});

